export const MEMBERSHIP_DEBUGGER_ROUTE = {
  name: 'Segment User Lookup',
  path: 'membershipDebugger',
};
